// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1l1W2","selected":"Chip_selected__3LNPR"};